import React, {useEffect, useState} from "react";
import Column from "./Column";
import {DragDropContext} from "react-beautiful-dnd";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import kanbanPattern from "./data";
import {updateContribution} from "./contributionsActions";
import {loadProject} from "../project/one-project/projectAction";
import AddButtonFullText from "../buttons/AddButtonFullText";
import ContributionModal from "../modal/ContributionModal";

const Kanban = () => {

    const {contributions, id: projectId} = useSelector(state => state.project)
    const dispatch = useDispatch()
    const [pattern] = useState(kanbanPattern)
    const [isOpenAddContributionModal, setIsOpenAddContributionModal] = useState(false)
    const [data, setData] = useState({})

    useEffect(() => {
        let tasks = {}
        contributions.forEach((c) => {
            let taskId = String(c.id)
            tasks[taskId] = {
                ...c,
                id: taskId
            }
        })
        const newColumns = {}
        // eslint-disable-next-line array-callback-return
        pattern.columnOrder.map(columnId => {
            const taskIds = contributions.filter(c => c.state === columnId).map(c => c.id)
            const column = pattern.columns[columnId]
            newColumns[columnId] = {
                ...column,
                id: columnId,
                tasksIds: taskIds
            }
        })
        const newState = {
            ...pattern,
            tasks: tasks,
            columns: newColumns
        }
        setData(newState)

    }, [contributions, pattern])


    const onDragEnd = async (result) => {
        const {destination, source, draggableId} = result
        if (!destination) return
        // check if the location change
        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return
        }
        const start = data.columns[source.droppableId]
        const finish = data.columns[destination.droppableId]

        // if start ad finish column are the same
        if (start === finish) {
            return
        }

        // Moving from one list to another
        const startTasksIds = Array.from(start.tasksIds)
        startTasksIds.splice(source.index, 1)
        const newStart = {
            ...start,
            tasksIds: startTasksIds
        }
        const finishTasksIds = Array.from(finish.tasksIds)
        finishTasksIds.splice(destination.index, 0, draggableId)
        const newFinish = {
            ...finish,
            tasksIds: finishTasksIds
        }

        const newState = {
            ...data,
            columns: {
                ...data.columns,
                [newStart.id]: newStart,
                [newFinish.id]: newFinish,
            }
        }
        setData(newState)
        await dispatch(updateContribution(draggableId, {state: destination.droppableId}))
        await dispatch(loadProject(projectId))
    }

    const displayModal = () => {
        if (isOpenAddContributionModal){
            return(
                <ContributionModal setIsOpen={setIsOpenAddContributionModal}/>
            )
        }
    }

    return (
        <Container>
            {displayModal()}
            <DragDropContext
                onDragEnd={onDragEnd}
            >
                <AddButtonFullText
                    title={"Ajouter une idée"}
                    setUpdate={setIsOpenAddContributionModal}
                    setId={setIsOpenAddContributionModal}
                />
                <Columns>
                    {data.hasOwnProperty("columns") &&
                    data.columnOrder.map((columnId) => {
                        const column = data.columns[columnId]
                        const tasks = column.tasksIds.map(taskId => data.tasks[taskId])
                        return <Column key={column.id} column={column} tasks={tasks}/>
                    })}
                </Columns>

            </DragDropContext>
            {displayModal()}
        </Container>

    )
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  align-items: center;
  justify-content: center;
`
const Columns = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export default Kanban